import React from 'react'
import Feedback from '../feedback'

const FeedbackFr = () => {
    return <Feedback languageCode="en" />
}

export default FeedbackFr
